// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__PyMBd","clinicsSelect":"TableHeading_clinicsSelect__3aEIE"};